<template>
    <div class="TPersonalNav">
        <div class="TPN-container px-40">
            <div class="TPNleft" @click="routLinkTo('/indexpage/notice')">
                <i class="el-icon-bell nav-icon"></i>
                <span class="nav-text">Notice</span>
                <Badge class="zxbadge" :num="noticeNum" :isDot="true"/>
            </div>
            <div class="TPNright">
                <div class="nav-links">
                    <div class="nav-item"
                    v-for="(item,index) in this.arr.right"
                    :key="index"
                    @click="routLinkTo(item.route)">
                        <span class="nav-text">{{ item.des }}</span>
                        <Badge class="zxbadge" :num="item.notice" :size="'regular'"/>
                        <span class="divider" v-if="index != arr.right.length -1">|</span>
                    </div>
                </div>
                
                <div class="nav-actions">
                    <div class="nav-action-item" @click="routLinkTo('/cart/shoppingCart')">
                        <i class="el-icon-shopping-cart-2 nav-icon"></i>
                        <Badge class="zxbadge" :num="cartNum" :size="'regular'"/>
                    </div>
                    <div class="nav-action-item" @click="handleChatToggle">
                        <i class="el-icon-chat-dot-round nav-icon"></i>
                        <Badge class="zxbadge" :num="0" :size="'regular'"/>
                    </div>
                    <MessagingPanel :visible="messagingVisible" @close="messagingVisible = false" />
                    <el-dropdown @command="handleCommand" trigger="click">
                      <div class="nav-action-item user-dropdown-link">
                        <i class="el-icon-user nav-icon"></i>
                      </div>
                      <el-dropdown-menu slot="dropdown" class="premium-dropdown">
                        <el-dropdown-item :command="1"><i class="el-icon-user"></i> User Center</el-dropdown-item>
                        <el-dropdown-item :command="0" :class="{logout: status === 1}">
                            <i :class="status === 0 ? 'el-icon-key' : 'el-icon-switch-button'"></i>
                            {{ status === 0 ? 'Login': 'Logout'}}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Badge from '@/components/common/Badge'
import MessagingPanel from '@/components/common/MessagingPanel'
import {mapGetters} from 'vuex'
import { getToken, removeToken } from '@/axios/cookies.js'
import {articleList} from '@/api/article.js'
export default {
  components: { Badge, MessagingPanel },
    name: 'TopPersonalNav',
    data () {
        return {
            arr: {
                'right': [
                    { 'des': 'Coupons', 'route': '/coupons', 'notice': 0 },
                    { 'des': 'User Center', 'route': '/userCenter', 'notice': 0 },
                    { 'des': 'My Orders', 'route': '/myOrder', 'notice': 0 }
                ]
            },
            status: 1,
            noticeNum: 0,
            messagingVisible: false
        }
    },
    computed: {
        ...mapGetters(['cartNum', 'userInfo'])
    },
    created () { 
        this.isLogin()
        this.getNoticeCount()
    },
    methods: {
        async getNoticeCount() {
            try {
                const res = await articleList()
                if (res.status === 200) {
                    const lastReadTime = this.userInfo.lastNoticeReadTime ? new Date(this.userInfo.lastNoticeReadTime).getTime() : 0
                    const unreadList = res.data.filter(item => {
                        const createTime = new Date(item.createTime || item.addTime).getTime()
                        return createTime > lastReadTime
                    })
                    this.noticeNum = unreadList.length
                }
            } catch (error) {
                console.error('Failed to fetch notice count', error)
            }
        },
        routLinkTo (val) {
            if (val === '/vip') { return this.$message.warning('Member features are not yet available') }
            if (!val || val === this.$route.path) return
            this.$router.push(val)
        },
        handleCommand (command) {
            this.isLogin()
            if (command) {
                this.$router.push('/userCenter')
            } else {
                if (this.status) {
                    removeToken()
                    this.$store.commit('reset')
                    this.isLogin()
                    this.routLinkTo('/indexpage/index')
                } else {
                    this.$store.commit('setLoginVisible', true)
                }
            }
        },
        handleChatToggle() {
            if (!getToken()) {
                this.$store.commit('setLoginVisible', true)
                return
            }
            this.messagingVisible = !this.messagingVisible
        },
        isLogin () { this.status = !getToken() ? 0 : 1 }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.TPersonalNav {
    height: 40px;
    background-color: $gray-900;
    color: rgba($white, 0.7);
    font-size: 13px;
    display: flex;
    align-items: center;

    .TPN-container {
        max-width: 1440px;
        width: 100%;
        margin: 0 auto;
        padding: 0 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}

.TPNleft {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    position: relative;
    transition: $transition-fast;
    &:hover { color: $white; }

    .zxbadge {
        position: absolute;
        top: 2px;
        right: -10px;
    }
}

.TPNright {
    display: flex;
    align-items: center;
    gap: 24px;
}

.nav-links {
    display: flex;
    align-items: center;
    .nav-item {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;
        transition: $transition-fast;
        &:hover { color: $white; }
        
        .divider {
            margin: 0 12px;
            color: rgba($white, 0.2);
            cursor: default;
        }
    }
}

.nav-actions {
    display: flex;
    align-items: center;
    gap: 15px;

    .nav-action-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        position: relative;
        transition: $transition-fast;
        padding: 5px;
        border-radius: 4px;

        &:hover {
            color: $white;
            background-color: rgba($white, 0.1);
        }

        .nav-icon {
            font-size: 18px;
        }

        .zxbadge {
            position: absolute;
            top: -2px;
            right: -8px;
        }
    }
}

.premium-dropdown {
    border-radius: $border-radius-md;
    border: none;
    box-shadow: $shadow-lg;
    
    .logout {
        color: $error-color;
        &:hover {
            background-color: rgba($error-color, 0.05) !important;
            color: $error-color !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopPersonalNav.vue